module.exports = __webpack_public_path__ + "static/kitchen_2K-17921c8d5ef9dcc71cdcaaaf43a7c448.jpg";